
export class PaymentVerifyResponse {
  error: boolean;
  message: string;
  profileId: string;
  accountId: string;
}
